import { createAxiosInstance } from "~/plugins/axios.plugin";

class PostService {
  constructor() {
    this.client = createAxiosInstance({ baseURL: process.env.PLATAFORMA_API_V2, useAccessToken: true });
  }

  createPost(params) {
    return this.client.post(`/content/academics-main/${params.academicMainId}/topics/${params.topicId}/posts`, params.body);
  }

  editPost(params) {
    return this.client.patch(`/content/academics-main/${params.academicMainId}/topics/${params.topicId}/posts/${params.postId}`, params.body);
  }

  addPostLike(params) {
    return this.client.post(`/content/academics-main/${params.academicMainId}/topics/${params.topicId}/posts/${params.postId}/likes`);
  }

  removePostLike(params) {
    return this.client.delete(`/content/academics-main/${params.academicMainId}/topics/${params.topicId}/posts/${params.postId}/likes`);
  }

  addTopicLike(params) {
    return this.client.post(`/content/academics-main/${params.academicMainId}/topics/${params.topicId}/likes`);
  }

  removeTopicLike(params) {
    return this.client.delete(`/content/academics-main/${params.academicMainId}/topics/${params.topicId}/likes`);
  }

  getPostByParentPostId(params) {
    return this.client.get(`/content/academics-main/${params.academicMainId}/topics/${params.topicId}/posts/${params.postId}`);
  }
};

export default new PostService();
